// extracted by mini-css-extract-plugin
module.exports = {"ExternalLink":"external-link_ExternalLink__wFmxC","ExternalLinkInText":"external-link_ExternalLinkInText__NurzC","ExternalLinkButton":"external-link_ExternalLinkButton__N7UOl"};